import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { AuthService } from '../../../shared/services/auth.service';
import { properties } from '../../../../environments/properties';
import { ParamService } from '../../../shared/services/param.service';
import { _windowUtil, findNestedObj } from '../../../shared/utils/ui-utils';
import { Observable, throwError } from 'rxjs';
import { catchError, map} from 'rxjs/operators';
import { RegistrationSubscriptionService } from '../../../shared/services/registration-subscription.service';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { LogService } from 'src/app/shared/services/log.service';

declare let $: any;

@Component({
    selector: 'snap-landing-mobile-page',
    templateUrl: './snap-landing-mobile.component.html',
    styleUrls: ['./snap-landing-mobile.component.scss'],
    providers: [SubscriptionService, RegistrationSubscriptionService],
})
export class SnapLandingMobileComponent implements OnInit {
    public plans$: Observable<any>;
    userInfo: any;
    plansResponse: any;
    isLoggedInTokenValid: boolean;
    currentEnvironment;
    freshpassTilesComponent;
    frequentlyAskedQuestion;
    termsContent;
    showFrequentlyAskedQuestion = false;
    showTermsContent = false;
    snapBenefitsJSON: any;
    banner;
    public windowUtil = _windowUtil(window);
    showPageLoader = true;
    easyStepsComponent;
    showEasyStepsComponent: boolean = false;

    private observer: MutationObserver;
    props = properties;

    constructor(
        public subscriptionService: SubscriptionService,
        public registrationSubscriptionService: RegistrationSubscriptionService,
        public authService: AuthService,
        public paramService: ParamService,
        public _http: HttpClient,
        private logService: LogService
    ) {
        this.banner = this.paramService.banner;
    }

    ngAfterViewInit(): void {
        this.hideCookiesConsent();
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    hideCookiesConsent(): void {
        const bodyNode = document.body;
        const config = { childList: true, subtree: true };

        this.observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === properties.snapBenefits.childList) {
                    const element = document.getElementById(this.props.cookiesOneTrustConsentEle);
                    if (element) {
                        element.style.display = 'none';
                        this.observer.disconnect();
                        break;
                    }
                }
            }
        });

        this.observer.observe(bodyNode, config);
    }

    ngOnInit(): void {
        const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        const receiveMessage = window[eventMethod];
        const messageEvent = 'setPartnerToken';
        const $this = this;
        $('.body-wrapper-footer').addClass('mask');
        $('.unified-header').addClass('mask');
        receiveMessage(messageEvent, function (e) {
            if (e && e.detail) {
                let userInfo = e.detail;
                userInfo = JSON.parse(userInfo);
                if (userInfo.token) {
                    userInfo.authToken = userInfo.token;
                    userInfo.SWY_SHOP_TOKEN = userInfo.token;
                    const isTokenValid = $this.subscriptionService.checkMobileTokenValidity(userInfo);
                    $this.logService.log('Web View : Request Payload : ' + JSON.stringify(userInfo));
                    $this.logService.log('Web View : token validity : ' + isTokenValid);
                    if (isTokenValid) {
                        $this.userInfo = userInfo;
                        $this.currentEnvironment = $this.userInfo.env;
                        $this.getFreshPassBenefits($this.currentEnvironment);
                        $this.getPromotionPlans($this.currentEnvironment, $this.userInfo);
                        $this.fetchEasyStepsFragment($this.currentEnvironment);
                        $this.showPageLoader = false;
                        $this.subscriptionService
                            .getFrequentlyAskedComponent($this.currentEnvironment)
                            .subscribe({
                                next: (data) => {
                                    if (data) {
                                        $this.frequentlyAskedQuestion = data;
                                        $this.showFrequentlyAskedQuestion = true;
                                        $this.logService.log('Web View :  FAQs fetched successfully');
                                        setTimeout(() => {
                                            $('.accordion-header').toggleClass('inactive-header');
                                            $('.display-type').each(function () {
                                                const displayType = $(this).attr('data-display-type');
                                                if (displayType === 'expandFirst') {
                                                    $(this)
                                                        .find('.accordion-header')
                                                        .first()
                                                        .toggleClass('active-header')
                                                        .toggleClass('inactive-header');
                                                    $(this)
                                                        .find('.accordion-content')
                                                        .first()
                                                        .slideDown()
                                                        .toggleClass('open-content');
                                                } else if (displayType === 'expanded') {
                                                    $(this)
                                                        .find('.accordion-header')
                                                        .toggleClass('active-header')
                                                        .toggleClass('inactive-header');
                                                    $(this)
                                                        .find('.accordion-content')
                                                        .slideDown()
                                                        .toggleClass('open-content');
                                                }
                                            });

                                            // The Accordion Effect
                                            $('.accordion-header').each(function () {
                                                if ($(this).hasClass('active-header')) {
                                                    $('.accordion-header').attr('aria-expanded', 'true');
                                                } else {
                                                    $(this).attr('aria-expanded', 'false');
                                                }
                                            });

                                            $('.accordion-header').click(function () {
                                                if ($(this).is('.inactive-header')) {
                                                    $(this)
                                                        .toggleClass('active-header')
                                                        .toggleClass('inactive-header');
                                                    $(this).attr('aria-expanded', 'true');
                                                    $(this).next().slideToggle().toggleClass('open-content');
                                                } else {
                                                    $(this)
                                                        .toggleClass('active-header')
                                                        .toggleClass('inactive-header');
                                                    $(this).attr('aria-expanded', 'false');
                                                    $(this).next().slideToggle().toggleClass('open-content');
                                                }
                                            });

                                            $('.accordion-header').keypress(function (e) {
                                                var key = e.which;
                                                if (key == 13) {
                                                    if ($(this).is('.inactive-header')) {
                                                        $(this)
                                                            .toggleClass('active-header')
                                                            .toggleClass('inactive-header');
                                                        $(this).attr('aria-expanded', 'true');
                                                        $(this).next().slideToggle().toggleClass('open-content');
                                                    } else {
                                                        $(this)
                                                            .toggleClass('active-header')
                                                            .toggleClass('inactive-header');
                                                        $(this).attr('aria-expanded', 'false');
                                                        $(this).next().slideToggle().toggleClass('open-content');
                                                    }
                                                }
                                            });
                                        }, 2000);
                                    }
                                },
                                error: (error) => {
                                    console.error(`Error fetching FAQ Component: ${error}`);
                                },
                                complete: () => {}
                            });
                        $this.subscriptionService.getTermsComponent(this.currentEnvironment).subscribe({
                            next: (data) => {
                                if (data) {
                                    $this.termsContent = data;
                                    $this.showTermsContent = true;
                                    $this.logService.log('Web View :  getTermsComponent fetched successfully');
                                }
                            },
                            error: (error) => {
                                console.error(`Error fetching Terms Component: ${error}`);
                            },
                            complete: () => {}
                        });
                    }
                } else {
                    $this.logService.log('Web View : ' + ' Token invalid, calling refreshPartnerToken event for Mobile');
                    console.error('>>>> call refresh token from wbkit');
                    const responseJson = '{"status":"ok"}';
                    const event = new CustomEvent('refreshPartnerToken', { detail: responseJson });
                    window.dispatchEvent(event);
                }
            }
        }, false);
    }

    getFreshPassBenefits = (currentEnv): void => {
        this.subscriptionService.getFreshPassBenefitsJSONAPI(currentEnv).then(
            (response) => {
                const tileObj = findNestedObj(response, 'freshpasstileparsys');
                if (tileObj) {
                    this.snapBenefitsJSON = tileObj;
                }
                this.logService.log('Web View :  easy steps fetched successfully');
            },
            (error) => {
                console.error(`error fetching experience fragment ${error}`);
            }
        );
    }


    fetchEasyStepsFragment(currentEnvironment) {
        this.subscriptionService.fetchAEMEasySteps(currentEnvironment).subscribe({
            next: (data) => {
                if (data) {
                    this.easyStepsComponent = data;
                    this.showEasyStepsComponent = true;
                }
            },
            error: (error) => {
                console.error(`error fetching EasyStepsFragment ${error}`);
            },
            complete: () => {}
        });
    }

    getPromotionPlans(currentEnvironment, userInfo) {
        this.getPlans(currentEnvironment, userInfo).subscribe({
            next: (response) => {
                this.logService.log('Web View :  promotionPlans fetched successfully');
                this.logService.log('Web View :  promotionPlans response: ' + JSON.stringify(response));
                this.plansResponse = response;
            },
            error: (error) => {
                console.error(`Error fetching promotion plans: ${error}`);
            },
            complete: () => {}
        });
    }

    public getApplicationDomainURL(currentEnvironment) {
        let domain = '';
        if (currentEnvironment.indexOf('prod') >= 0) {
            domain = 'https://www.' + this.banner + '.com';
        } else {
            domain = 'https://www-' + currentEnvironment + '.' + this.banner + '.com';
        }
        return domain;
    }

    public getPlans(currentEnvironment, userInfo): Observable<any> {
        const url = this.getApplicationDomainURL(currentEnvironment) + environment[currentEnvironment].dsJavaBasePath + environment[currentEnvironment].dsJavaServiceRestEndpoint;
        let headerObj = environment[currentEnvironment].subscriptionHeaders.deliverySubHttpJavaOptionsV4;
        this.replaceHeaderBanner(headerObj);
        let authToken;
        if (userInfo.SWY_SHOP_TOKEN) {
            authToken = `Bearer ${userInfo.SWY_SHOP_TOKEN}`;
        } else {
            authToken = 'Bearer';
        }
        let currentTime = new Date();

        const options = {
            headers: {
                ...headerObj,
                'Authorization': authToken,
                'x-swy-correlation-id': uuidv4(),
                'x-swy-date': currentTime.toString()
            }
        };
        return this._http.get(
            url, options)
            .pipe(map((data: any) => {
                return data;
            }),
                catchError(this.handleError)
            );
    }

    public handleError(errorResponse: HttpErrorResponse) {
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            const errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
            return throwError(() => new Error(errMsg));
        }
    }

    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy-banner']) {
                header['x-swy-banner'] = header['x-swy-banner'].replace(/\{banner\}/g, this.banner);
            }
        }
    }
}
